import React, {useState, useEffect} from "react";
import ReactModal from "react-modal";

export default function ReportingModal(props) {
    const [note, setNote] = useState("");
    const [width, setWidth] = useState(window.innerWidth);
    const breakpoint = 600;

    useEffect(() => {
        window.addEventListener("resize", () => setWidth(window.innerWidth))
    }, []);
    
    var selectedGame = props.selectedGame;
    var reportingGame = props.reportingGame;

    let reportGame = async (game, note) => {
        console.log("reporting game: " + game.appID);
        await fetch(`gamedata/report`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                'AppId': game.appID,
                'Note': note
            })
        });
        setNote("");
        props.clearReportingGame();
    }
    
    return (<ReactModal
        isOpen={selectedGame !== null && reportingGame}
        onRequestClose={() => props.clearReportingGame()}
        shouldCloseOnOverlayClick={true}
        style={{
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                zIndex:1000
            },
            content: {
                backgroundColor: '#0f0f0f',
                border: 'none',
                minWidth: '40%',
                height: 'fit-content',
                inset: width > breakpoint ? '15% 30% 0 30%' : '15% 5% 0 5%',
                alignContent: 'center',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
            }
        }}
    >
        <div>
            <button
                style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    fontSize: '40px',
                    boxShadow: 'none',
                    padding: '0',
                    lineHeight: '32px',
                    height: '35px',
                }}
                onClick={() => props.clearReportingGame()}
            >
                X
            </button>
            <h2 style={{textAlign: 'center', padding: '0px 40px 0px 40px'}}>Report Game Compatibility</h2>
            <form>
                <label>Game Title:<input
                    type="text"
                    value={selectedGame?.name}
                    disabled={true}
                /></label>
                <label>Note:<textarea
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                /></label>
                <input
                    type="submit"
                    className={"primary"}
                    value="Submit Report"
                    onClick={(e) => {
                        reportGame(selectedGame, note)
                        e.preventDefault();
                    }}
                />
            </form>
        </div>
    </ReactModal>)
}